import { CommonModule } from '@angular/common';
import { Component, Input, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-custom-popover',
  standalone: true,
  templateUrl: './custom-popover.html',
  styleUrls: ['./custom-popover.less'],
  imports:[CommonModule]
})
export class CustomPopoverComponent {
  @Input() content: string | null = null;
  @Input() width: string = '250px';
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() hideDelay = 1000;

  show = false;
  private hideTimeout: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    clearTimeout(this.hideTimeout);
    this.show = true;
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.hideTimeout = setTimeout(() => {
      this.show = false;
    }, this.hideDelay);
  }
}
